export default __webpack_public_path__ + "static/media/poly-icon.7d24640e.svg";